import React, { Suspense, useEffect, useState } from "react";
import { Route } from "react-router-dom";
import Loading from "../../components/common/Loading";
import "../../App.css";
import "./mainlayout.css";
import Header from "../../components/common/header/header";
import Draggable from "react-draggable";

const MainLayout = (props) => {
  const [setSession, setSetSession] = useState(false);
  const [onP2PCall, setOnP2PCall] = useState(false);
  const remoteId = React.useRef(null);

  useEffect(() => {
    const { instaSignaler } = props;

    const handleClosedWs = (event) => {
      // Handle closed WebSocket event
    };

    const handleCallEnded = (event) => {
      instaSignaler.setBusy(false);
      let remote = document.getElementById("remote");
      remote.style.transform = "scale(0, 0)";
    };

    const handleCallAccepted = (event) => {
      remoteId.current = event.remoteId;
      setOnP2PCall(true);
      // Additional logic for handling call acceptance can be added here
    };

    instaSignaler.on("closed-ws", handleClosedWs);
    instaSignaler.on("oncall-ended", handleCallEnded);
    instaSignaler.on("call-accepted", handleCallAccepted);

    return () => {
      instaSignaler.off("closed-ws", handleClosedWs);
      instaSignaler.off("call-accepted", handleCallAccepted);
    };
  }, [props.instaSignaler]);

  const leaveP2PCall = () => {
    props.instaSignaler.sendEndCallRequest(remoteId.current);
  };

  const handleClose = () => {
    setSetSession(false);
  };

  const gotoBuy = () => {
    props.history.push("/buy-room");
  };

  return (
    <div className="mainLayout">
      {!props.excludeHeaderDomainName && props.headerOff !== true && <Header {...props} />}
      <Draggable>
        <div className={`floatingP2P ${!onP2PCall ? "hideout" : ""}`}>
          <video id="remote" playsInline />
          <video id="self" muted playsInline />
          <div
            className="circle circleMd endBg confBtns p2pEnd"
            onClick={leaveP2PCall}
          >
            <img src="/images/icons/hang-white.png" alt="icon" />
          </div>
        </div>
      </Draggable>
      <div
        className={`mainContainer ${
          props.excludeHeaderDomainName || props.headerOff ? "removeTop" : ""
        }`}
      >
        <Suspense fallback={<Loading />}>
          <Route exact path={props.path} component={props.component} />
        </Suspense>
      </div>
    </div>
  );
};

export default MainLayout;